
import Table from './Table';
const Tab2 = ({setSelectedTaxAccounts}) => {
  return (
   <div
      className="row mb-3"
      style={{ border: "1px solid rgba(50, 50, 50, 0.35)", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Tax Rates</p>
        <Table 
        setSelectedTaxAccounts={setSelectedTaxAccounts}
        />
      </div>
    </div>
  )
}

export default Tab2